const jobs = {
  bulk: {

    table: {
      direction: {
        distribute: 'Para a Escola',
        collect: 'Da escola',
        both: 'Para a Escola & Da Escola',
      },

    },

    direction: {
      to: 'Para a Escola',
      from: 'Da escola',
      both: 'Para a Escola & Da Escola',
    },

    form: {
      information: {
        details: {
          fields: {
            fromHour: 'As Escolas Começam às',
            toHour: 'As aulas terminam às',
            shift: 'Horário escolar',
            from: 'Casa',
            to: 'Escola',
          },
        },
        locations: {
          header: 'Escola',
          fields: {
            locations: 'Selecionar Escola'
          }
        },
      },
    },
  },

  forms: {
    information: {
      passengers: {
        header: 'Informações pessoais',
        label: 'Selecionar alunos'
      },
    }
  }
};

export default jobs;
